import { takeLatest, call, put } from 'redux-saga/effects';
import axiosInstance from '../../services/AuthHeader';
import { setSending, unsetSending } from '../reducers/serverCommunication';
import {
  setUpdateQuestionnaireResponseFailure,
  setUpdateQuestionnaireResponseRequest,
  setUpdateQuestionnaireResponseSuccess,
} from '../reducers/results';

export const SAGA_UPDATE_QUESTIONNAIRE_RESPONSE = 'SAGA_UPDATE_QUESTIONNAIRE_RESPONSE';

export function sendUpdateQuestionnaireResponse(payload) {
  return { type: SAGA_UPDATE_QUESTIONNAIRE_RESPONSE, payload };
}

const handleUpdateQuestionnaireResponse = async ({
  id,
  authored,
  questionnaire,
  status,
  subject,
  resourceType,
  extension,
  item,
}) =>
  axiosInstance
    .put('/fhir/QuestionnaireResponse/' + id, {
      id,
      authored,
      questionnaire,
      status,
      subject,
      resourceType,
      extension,
      item,
    })
    .then((res) => res.data);

export function* updateQuestionnaireResponse(action) {
  yield put(setSending);
  yield put(setUpdateQuestionnaireResponseRequest);
  try {
    const response = yield call(handleUpdateQuestionnaireResponse, action.payload);
    yield put(setUpdateQuestionnaireResponseSuccess(response));
  } catch (error) {
    yield put(setUpdateQuestionnaireResponseFailure(error.response));
  } finally {
    yield put(unsetSending);
  }
}

export function* watchForUpdateQuestionnaireResponse() {
  yield takeLatest(SAGA_UPDATE_QUESTIONNAIRE_RESPONSE, updateQuestionnaireResponse);
}
